import { Component, ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-archivio',
  templateUrl: './archivio.component.html',
  styleUrls: ['./archivio.component.css']
})
export class ArchivioComponent {
    window:any=<any>window;
    $:any=<any>this.window.$;
    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };
    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    updateView:any = () => {
        this.zone.run(() => {
            if(!this.queryparams()['type'] || !this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteTimbrataModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#timbrataModal', element: this.elementref.nativeElement }});
                this.initModel();
            }
            if(this.queryparams()['type'] == 'delete' && !!this.queryparams()['timbrata'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#timbrataModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#deleteTimbrataModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'create' && !this.queryparams()['timbrata'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteTimbrataModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#timbrataModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'update' && !!this.queryparams()['timbrata'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteTimbrataModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#timbrataModal', element: this.elementref.nativeElement }});
                this.temp_orario = {
                    inizio: this.getTimbrata().inizio.timestamp,
                    fine: this.getTimbrata().fine.timestamp
                };
            }
            this.populateCollection();
            this.cd.detectChanges();
        });
    };

    filter_expanded:any = false;
    filter:any = {
        text: '',
        group: '',
        client: '',
        worker: '',
        from: 0,
        to: 0
    };
    timbrata:any = {
        owner: "",
        parent: this.window.appInfo.public_token_parent,
        client: "",
        assegnazione: "",                      // public_token dell'assegnazione
        id_calendar: "",                          // id del obj nel calendar dell'assegnazione
        inizio: {
            timestamp: new Date().getTime(),                     // timestamp di inizio lavoro
            position: [0, 0]                       // array contenente latitudine e longitudine
        },
        fine: {
            timestamp: new Date().getTime(),                     // timestamp di inizio lavoro
            position: [0, 0]                       // array contenente latitudine e longitudine
        }
        /*geometry: {
            "type" => "Point",
            "coordinates" => $params['coordinates']
        }*/
    };
    temp_orario:any = {
        inizio: 0,
        fine: 0
    };
    datepicker1:any;
    datepicker2:any;
    datepicker_filter_from:any;
    datepicker_filter_to:any;
    collection:any = [];
    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router,
        private elementref: ElementRef,
        private zone: NgZone
    ) {}

    ngAfterContentInit() {
        this.route.queryParams.subscribe((p:any) => this.updateView());
        this.window.usher.element.addEventListener('change', this.updateView.bind(this));
        this.window.bigBucket.element.addEventListener('change', this.populateCollection.bind(this));
        this.window.geoBucket.element.addEventListener('change', this.populateCollection.bind(this));

        this.window.__mapsAuxObj.loadedPromise.then(() => {
            let input = this.elementref.nativeElement.querySelector("#indirizzo_autocomplete_inizio"),
                autocompleteIndirizzoInizio = new this.window.google.maps.places.Autocomplete(input);
            this.window.google.maps.event.addListener(autocompleteIndirizzoInizio, 'place_changed', () => {
                this.getTimbrata().inizio.position = [autocompleteIndirizzoInizio.getPlace().geometry.location.lat(), autocompleteIndirizzoInizio.getPlace().geometry.location.lng()];
            });

            let input2 = this.elementref.nativeElement.querySelector("#indirizzo_autocomplete_fine"),
                autocompleteIndirizzoFine = new this.window.google.maps.places.Autocomplete(input2);
            this.window.google.maps.event.addListener(autocompleteIndirizzoFine, 'place_changed', () => {
                this.getTimbrata().fine.position = [autocompleteIndirizzoFine.getPlace().geometry.location.lat(), autocompleteIndirizzoFine.getPlace().geometry.location.lng()];
            });
            this.cd.detectChanges();
        });

        this.datepicker1 = new this.window.HPDatepicker({
            parent: this.elementref.nativeElement,
            callback: (date) => {
                this.temp_orario.inizio = date.getTime();
            }
        });
        this.datepicker2 = new this.window.HPDatepicker({
            parent: this.elementref.nativeElement,
            callback: (date) => {
                this.temp_orario.fine = date.getTime();
            }
        });
        this.datepicker_filter_from = new this.window.HPDatepicker({
            parent: this.elementref.nativeElement,
            allow_empty: true,
            callback: (date) => {
                if(!date) return this.filter.from = 0;
                this.filter.from = date.getTime();
                this.populateCollection();
            }
        });
        this.datepicker_filter_to = new this.window.HPDatepicker({
            parent: this.elementref.nativeElement,
            allow_empty: true,
            callback: (date) => {
                if(!date) return this.filter.to = 0;
                this.filter.to = date.getTime();
                this.populateCollection();
            }
        });
    };

    resetFilter = () => {
        this.filter = {
            text: '',
            group: '',
            client: '',
            worker: '',
            from: 0,
            to: 0
        };
        this.populateCollection();
    };

    ngOnDestroy() {
        this.window.usher.element.removeEventListener('change', this.updateView.bind(this));
    };
    
    handleModal = (timbrata:any = undefined, type:any = undefined) => {
        this.router.navigate([`/archivio`], { queryParams: this.changeQueryParam({ "timbrata" : timbrata, "type" : type }) });
    };
    
    populateCollection = () => {
        this.collection.length = 0;
        this.collection.push(...(this.window.flowup.badge.timbrate?.filter(timbrata => {
            if(!this.filter.text && 
                !this.filter.group && 
                !this.filter.client && 
                !this.filter.worker && 
                !this.filter.from && 
                !this.filter.to) return true;
    
            let filter_text = this.filter.text?.toLowerCase() || "",
                client = this.getUsers(timbrata.client)[0] || {},
                worker = this.getUsers(timbrata.owner)[0] || {},
                assegnazione = this.getAssegnazioni(timbrata.assegnazione, true) || {};
            if(!!filter_text && 
                !client.public_configuration?.nome?.toLowerCase().includes(filter_text) &&
                !client.email?.toLowerCase().includes(filter_text) &&
                !worker.public_configuration?.nome?.toLowerCase().includes(filter_text) &&
                !worker.email?.toLowerCase().includes(filter_text) &&
                !assegnazione.configuration?.sede?.toLowerCase().includes(filter_text)) return false;
            if(!!this.filter.group && 
                !client.public_configuration?.groups?.find(e => e.id == this.filter.group) &&
                !worker.public_configuration?.groups?.find(e => e.id == this.filter.group)) return false;
            if(!!this.filter.client && 
                client.public_token != this.filter.client) return false;
            if(!!this.filter.worker && 
                worker.public_token != this.filter.worker) return false;
            if(!!this.filter.from &&
                timbrata.inizio.timestamp < this.filter.from) return false;
            if(!!this.filter.to &&
                timbrata.inizio.timestamp > this.filter.to) return false;
            return true;
        }) || []));
    };

    openSelectAssegnazione = () => {
        this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#assegnazioneModal', element: this.elementref.nativeElement }});
    };

    closeSelectAssegnazione = () => {
        this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#assegnazioneModal', element: this.elementref.nativeElement }});
    };

    initModel = () => {
        this.timbrata = {
            owner: "",
            parent: this.window.appInfo.public_token_parent,
            client: "",
            assegnazione: "",                      // public_token dell'assegnazione
            id_calendar: "",                          // id del obj nel calendar dell'assegnazione
            inizio: {
                timestamp: new Date().getTime(),                     // timestamp di inizio lavoro
                position: [0, 0]                       // array contenente latitudine e longitudine
            },
            fine: {
                timestamp: new Date().getTime(),                     // timestamp di inizio lavoro
                position: [0, 0]                       // array contenente latitudine e longitudine
            }
        };
        this.temp_orario = {
            inizio: 0,
            fine: 0
        };
    };

    get = (id:any = false) => this.collection.filter(timbrata => !id || timbrata.id == id) || [];

    getTimbrata = () => {
        if(!!this.queryparams()['timbrata'] && this.queryparams()['type'] != 'create') return this.get(this.queryparams()['timbrata'])[0] || this.timbrata;
        return this.timbrata;
    };
  
    getAssegnazioni = (pt:any = undefined, archived:any = false) => {
        let filtered = this.window.geoBucket.getBuckets()[this.window.appInfo.buckets.geoBucket.assegnazione]?.objects?.filter(assegnazione => (!pt || assegnazione.public_token == pt) && !!assegnazione.configuration.archived == archived) || [];
        return !!pt ? filtered[0] : filtered;
    };

    getUsers = (pt:any = false, type:any = false) => [...this.window.usher.getChildren(), this.window.usher.get()]?.filter(user => (!pt || user.public_token == pt) && (!type || user.public_configuration?.type == type)) || [];

    getOrario = (timbrata:any) => {
        if(!timbrata.id) return '';
        return `${this.window.moment(timbrata.inizio.timestamp).format("DD/MM/YYYY HH:mm")}${!!timbrata.fine.timestamp ? ` - ${this.window.moment(timbrata.fine.timestamp).format("DD/MM/YYYY HH:mm")}` : ''}`;
    };

    selectAssegnazione = (assegnazione:any, id:any) => {
        this.getTimbrata().assegnazione = assegnazione;
        this.getTimbrata().id_calendar = id;
        this.closeSelectAssegnazione();
    };

    openMap = (type:any = undefined) => {
        if(!type) return;
        let cords = (type == 'inizio') ? this.getTimbrata().inizio.position : (type == 'fine') ? this.getTimbrata().fine.position : [0, 0];
        this.window.flowup.signal.emit({name: "open-browser", detail: { url: `https://www.google.com/maps/place/${cords[0]},${cords[1]}`}});
        return;
    };

    check = (timbrata:any = undefined, assegnazione:any = undefined) => {
        if(!!timbrata) {
            if(!timbrata?.assegnazione) {
                this.window.flowup.signal.emit({name: "notification", detail: { type: "danger", text: "Attenzione! Devi scegliere un'assegnazione per il quale vuoi registrare la timbrata." }});
                return false;
            }
            if(!timbrata?.inizio?.timestamp) {
                this.window.flowup.signal.emit({name: "notification", detail: { type: "danger", text: "Attenzione! Inserire l'orario di entrata" }});
                return false;
            }
            if(timbrata?.inizio?.timestamp == timbrata?.fine?.timestamp) {
                this.window.flowup.signal.emit({name: "notification", detail: { type: "danger", text: "Attenzione! L'entrata e l'uscita non possono avvenire nello stesso momento" }});
                return false;
            }
        }
        if(!!assegnazione) {
            if(!!assegnazione?.geolocation_requested && (timbrata?.inizio?.position[0] == 0 && timbrata?.inizio?.position[1] == 0 || timbrata?.fine?.position[0] == 0 && timbrata?.fine?.position[1] == 0)) {
                this.window.flowup.signal.emit({name: "notification", detail: { type: "danger", text: "Attenzione! L'assegnazione richiede la geolocalizzazione." }});
                return false;
            }
        }
        return true;
    };

    handleTimbrata = async () => {
        // Prendo l'oggetto timbrata (che sto modificando/aggiungendo) e l'oggetto assegnazione
        let assegnazione = this.getAssegnazioni(this.getTimbrata().assegnazione),
            obj_timbrata:any = this.getTimbrata();

        // Compilo tutti i campi dell'oggetto timbrata in base all'assegnazione che ho scelto.
        // Nel caso in cui la timbrata è in modifica, riassegno i campi perchè avrei potuto cambiarla
        obj_timbrata.owner = assegnazione.configuration?.dipendente?.public_token || "";
        obj_timbrata.client = assegnazione.configuration?.cliente?.public_token || "";
        obj_timbrata.inizio.timestamp = this.temp_orario.inizio;
        obj_timbrata.fine.timestamp = this.temp_orario.fine;
        if(!this.check(obj_timbrata, assegnazione)) return;
        try {
            await this.window.flowup.admin.badge.handleTimer(obj_timbrata);
            this.window.flowup.signal.emit({name: "notification", detail: { type: "success", text: "Timbrata aggiunta con successo." }});
            this.handleModal(undefined, undefined);
        } catch(e) {
            console.log(e);
            this.window.flowup.signal.emit({name: "notification", detail: { type: "danger", text: "Errore! Riprova più tardi." }});
        }
    };

    getSingleOrario = (type:any="inizio") => {
        if(!this.temp_orario[type]) return `Data non ancora selezionata`;
        return `${this.window.moment(this.temp_orario[type]).format("DD/MM/YYYY HH:mm")}`;
    };
    
    downloadReportCsv = async () => {
        const formatNow = this.window.moment().format("DD_MM_YYYY"),
            name = `Report_${formatNow}.csv`;
        let csv_text = "Dipendente,Cliente,Sede,Entrata,Uscita,Durata\r\n",
            formatted_collection = this.collection.map(e => new Object({
                worker: this.getUsers(e.owner)[0],
                client: this.getUsers(e.client)[0],
                inizio: e.inizio,
                fine: e.fine,
                sede: this.getAssegnazioni(e.assegnazione, true)?.configuration?.sede || ""
            }));
        if(!formatted_collection.length) return this.window.flowup.signal.emit({name: "notification", detail: { type: "danger", text: "Attenzione! Non ci sono timbrate scaricabili" }});
        formatted_collection.forEach(e => {
            let minutes = (e.fine.timestamp-e.inizio.timestamp)/1000/60,
                distanza_temporale = `${this.window.flowup.utils.getTimeFromMinutes(minutes)} ${minutes >= 60 ? 'ore' : 'minuti'}`;
            csv_text += `${e.worker?.public_configuration?.nome},${e.client?.public_configuration?.nome},${e.sede || "Non rilevata"}`;
            csv_text += `,${this.window.flowup.utils.getDateTime(e.inizio?.timestamp)},${this.window.flowup.utils.getDateTime(e.fine?.timestamp)},${distanza_temporale}\n`;
        });

        this.window.flowup.signal.emit({name: 'open-file', detail: {
            path: 'data:text/csv;charset=utf-8,' + encodeURI(csv_text),
            name: name
        }});
    };
}